<template>
  <div>
    <question-usage
      v-if="$page.props.user.current_team.plan !== 'Enterprise'"
      :faq-id="faq.id"
      class="mb-4"
      :show-based-on-used-percentage="true"
    />

    <div class="mb-6">
      <v-btn
        color="primary"
        class="mr-2"
        small
        :class="{
          'mb-2': $vuetify.breakpoint.xsOnly
        }"
        :block="$vuetify.breakpoint.xsOnly"
        @click="$inertia.visit(route('faq.create-question', faq.id))"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        {{ $t('Add question') }}
      </v-btn>

      <v-btn
        small
        color="primary"
        class="mr-2"
        :class="{
          'mb-2': $vuetify.breakpoint.xsOnly
        }"
        :block="$vuetify.breakpoint.xsOnly"
        @click="showCategoryDialog('create', 'category')"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        {{ $t('Add category') }}
      </v-btn>

      <v-btn
        color="primary"
        small
        :block="$vuetify.breakpoint.xsOnly"
        @click="importDialog.show = true"
      >
        <v-icon left>
          mdi-plus
        </v-icon>
        {{ $t('Import') }}
      </v-btn>
    </div>

    <manage-faq-list
      :key="faqListKey"
      :faq="faq"
      @edit-category="category => showCategoryDialog('edit', 'category', category)"
      @create-subcategory="category => showCategoryDialog('create', 'subcategory', category)"
      @edit-subcategory="subcategory => showCategoryDialog('edit', 'subcategory', subcategory)"
    />

    <import-questions-dialog
      v-model="importDialog.show"
      :faq-id="faq.id"
      @success="handleImportSuccess"
    />

    <category-edit-or-create-dialog
      ref="categoryDialog"
      v-model="categoryDialog.show"
      :title="categoryDialogTitle"
      :faq-id="faq.id"
      :mode="categoryDialog.mode"
      :category="categoryDialog.category"
      :is-subcategory="categoryDialog.isSubcategory"
      :images="images"
    />
  </div>
</template>

<script>
import CategoryEditOrCreateDialog from '@/components/faq/CategoryEditOrCreateDialog';
import ImportQuestionsDialog from '@/components/faq/ImportQuestionsDialog';
import ManageFaqList from '@/components/faq/manage/ManageFaqList';
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';

export default {
  components: {
    ManageFaqList,
    CategoryEditOrCreateDialog,
    ImportQuestionsDialog
  },

  layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'manage',
      faq: page.data.props.faq
    }
  }, [page])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    images: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      categoryDialog: {
        show: null,
        mode: null,
        category: null,
        isSubcategory: false
      },
      importDialog: {
        show: false
      },
      faqListKey: new Date().getTime()
    }
  },

  computed: {
    categoryDialogTitle() {
      if (this.categoryDialog.mode === 'create') {
        return this.categoryDialog.isSubcategory ?
          this.$t('Add subcategory') : this.$t('Add category');
      } else if (this.categoryDialog.mode === 'edit') {
        return this.categoryDialog.isSubcategory ?
          this.$t('Edit subcategory') : this.$t('Edit category');
      }

      return '';
    }
  },

  watch: {
    'categoryDialog.show': function (value) {
      if (value === true) return;

      for (const key in this.categoryDialog) {
        this.categoryDialog[key] = null;
      }
    }
  },

  methods: {
    showCategoryDialog(mode, type, category = null) {
      this.categoryDialog.show = true;
      this.categoryDialog.mode = mode;
      this.categoryDialog.isSubcategory = type === 'subcategory';
      this.categoryDialog.category = category;
    },

    handleImportSuccess() {
      this.faqListKey = new Date().getTime();
      this.$root.refreshFaqPreview();
    }
  }
}
</script>